import { createSlice } from '@reduxjs/toolkit';

import { handleGetAdminRiskLevels } from './actions';
import { IAdminRiskLevelsState } from './slice.interface';

const initialState: IAdminRiskLevelsState = {
  data: [],
  isLoading: false,
  isReady: false,
  error: false,
};

export const adminRiskLevelsSlice = createSlice({
  name: 'admin-risk-levels',
  initialState,
  reducers: {
    removeAdminRiskLevels: (state: IAdminRiskLevelsState) => {
      state.data = [];
      state.isLoading = false;
      state.isReady = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(handleGetAdminRiskLevels.pending, (state: IAdminRiskLevelsState) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetAdminRiskLevels.rejected, (state: IAdminRiskLevelsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(handleGetAdminRiskLevels.fulfilled, (state: IAdminRiskLevelsState, action) => {
        state.data = action.payload.data;
        state.isLoading = false;
        state.isReady = true;
      });
  },
});

export const { removeAdminRiskLevels } = adminRiskLevelsSlice.actions;

export default adminRiskLevelsSlice.reducer;
